var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightEllipseBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1156,
    height: 480,
    viewBox: "0 0 1156 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1156,
    height: 480
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1156,
    height: 480,
    fill: "url(#paint0_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1119 424C1317.27 424 1478 263.27 1478 65C1478 -133.27 1317.27 -294 1119 -294C920.73 -294 760 -133.27 760 65C760 263.27 920.73 424 1119 424ZM1119.17 214.35C1201.56 214.35 1268.35 147.562 1268.35 65.175C1268.35 -17.2121 1201.56 -84 1119.17 -84C1036.79 -84 970 -17.2121 970 65.175C970 147.562 1036.79 214.35 1119.17 214.35Z",
    fill: "#ECEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M832 897C1030.27 897 1191 736.27 1191 538C1191 339.73 1030.27 179 832 179C633.73 179 473 339.73 473 538C473 736.27 633.73 897 832 897ZM832.175 687.35C914.562 687.35 981.35 620.562 981.35 538.175C981.35 455.788 914.562 389 832.175 389C749.788 389 683 455.788 683 538.175C683 620.562 749.788 687.35 832.175 687.35Z",
    fill: "#03B8EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.00000246723,
    y1: 260,
    x2: 1156,
    y2: 260,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3990"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightEllipseBg);
export default __webpack_public_path__ + "static/media/rightEllipseBg.da5675e3ff7ded0350b6aac1c488a2e9.svg";
export { ForwardRef as ReactComponent };